import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Services from "../components/Services";
import Stats from "../components/Stats";
import Features from "../components/Features";

const ServicesPage = () => {
  return (
    <>
      <Header />
      {/* <section className="section project" aria-labelledby="project-label"> */}
      <Services />
      <Stats />
      <Features />

      {/* </section> */}
      <Footer />
    </>
  );
};

export default ServicesPage;
